<section class="full-page-width-limiter">
  <h1>{{ text }}</h1>

  @if (description) {
    <span class="ingress">{{ description }}</span>
  }
  @if (!description) {
    <span class="ingress"><ng-content></ng-content></span>
  }
</section>
